import { render, staticRenderFns } from "./BoolUnionIcon.vue?vue&type=template&id=2527e459&"
import script from "./BoolUnionIcon.vue?vue&type=script&lang=js&"
export * from "./BoolUnionIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports